<template>
	<div name="capture" :id="id" class="print-section development-plan">
		<div class="print-tit">DEVELOPMENT PLAN</div>

		<div class="dp-block-tit"><i></i>리모델링 / 신축 자금계획 <small>· 향후 가치 제고(Value-add) 검토용</small></div>
		<div class="dp-two-col">
			<div class="dp-side">
				<div class="dp-side-tit">리모델링 <small>현 건물 유지 · 연면적 {{ areaP(dev.rmArea) }}평</small></div>
				<table class="dp-table">
					<thead><tr><th>항목</th><th>산정근거</th><th class="num">평단가</th><th class="num">금액</th></tr></thead>
					<tbody>
						<tr v-for="(r, i) in dev.remodelRows" :key="'rm' + i">
							<td>{{ r.label }}</td><td class="basis">{{ r.basis }}</td><td class="num">{{ r.unit }}만/평</td><td class="num">{{ money(r.amount) }}</td>
						</tr>
						<tr class="total"><td>총 공사비</td><td></td><td></td><td class="num">{{ money(dev.remodelTotal) }}</td></tr>
					</tbody>
				</table>
				<p class="dp-note">구조 유지로 인허가 부담이 적고 공기가 짧습니다(통상 3~5개월). 운영 정지 = 매출 공백이므로 층별 단계 시공을 권장합니다.</p>
			</div>
			<div class="dp-side">
				<div class="dp-side-tit">신축 <small>멸실 후 재건축 · 신축 연면적 약 {{ dev.nbArea }}평</small></div>
				<table class="dp-table">
					<thead><tr><th>항목</th><th>산정근거</th><th class="num">평단가</th><th class="num">금액</th></tr></thead>
					<tbody>
						<tr v-for="(r, i) in dev.newbuildRows" :key="'nb' + i">
							<td>{{ r.label }}</td><td class="basis">{{ r.basis }}</td><td class="num">{{ r.unit }}만/평</td><td class="num">{{ money(r.amount) }}</td>
						</tr>
						<tr class="total"><td>총 사업비</td><td></td><td></td><td class="num">{{ money(dev.newbuildTotal) }}</td></tr>
					</tbody>
				</table>
				<p class="dp-note">멸실~준공 통상 12~18개월 운영 중단. 자산가치·임대료 상승폭이 크고 용적률 여유분 활용이 가능합니다. 사업성은 별도 검토가 필요합니다.</p>
			</div>
		</div>

		<div class="dp-block-tit"><i></i>총 소요자금 비교 <small>· 매입 + 가치제고</small></div>
		<div class="dp-cards">
			<div class="dp-card">
				<div class="dp-card-label">매입만 (현 상태)</div>
				<div class="dp-card-value">{{ eok1(funding.buyOnly) }}억</div>
				<div class="dp-card-sub">즉시 운영 · 추가 공사 없음</div>
			</div>
			<div class="dp-card">
				<div class="dp-card-label">매입 + 리모델링</div>
				<div class="dp-card-value">약 {{ eok(funding.buyRemodel) }}억</div>
				<div class="dp-card-sub">{{ eok1(funding.buyOnly) }}억 + {{ eok1(dev.remodelTotal) }}억</div>
			</div>
			<div class="dp-card dp-card--primary">
				<div class="dp-card-label">매입 + 신축</div>
				<div class="dp-card-value">약 {{ eok(funding.buyNewbuild) }}억</div>
				<div class="dp-card-sub">{{ eok1(funding.buyOnly) }}억 + {{ eok1(dev.newbuildTotal) }}억</div>
			</div>
		</div>

		<div class="page-footer-disclaimer">
			<div class="dp-assumption" v-if="dev.assumptions">가정: {{ dev.assumptions.gradeLabel }} 등급 · {{ dev.assumptions.regionLabel }} · 리모델링 적용 {{ dev.assumptions.ratioPct }}% · 단가기준 {{ dev.assumptions.baseDate }}</div>
			<div class="dp-sources-tit">산정근거 · 출처</div>
			<ol class="dp-sources">
				<li v-for="(s, i) in devSources" :key="'dsrc' + i">{{ s }}</li>
			</ol>
			<p class="dp-disc">※ 취득세·운영중단 기회비용은 별도이며, 본 자료는 투자 판단의 근거로 사용될 수 없습니다.</p>
			<div class="dp-legal">
				<p v-for="(line, i) in pageFooterLines" :key="'leg' + i">{{ line }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import { DEV_SOURCES, PAGE_FOOTER_LINES } from '@/utils/investment.mjs';

export default {
	name: 'DevelopmentPlanPage',
	props: {
		id: { type: String, default: 'capture_dev' },
		dev: { type: Object, required: true },
		funding: { type: Object, required: true },
	},
	data() {
		return { devSources: DEV_SOURCES, pageFooterLines: PAGE_FOOTER_LINES };
	},
	methods: {
		money(v) { return this.$formatMoney(v, this.$MONEY_FORMAT_TYPE.LOAN); },
		eok(man) { return Math.round((Number(man) || 0) / 10000); },
		eok1(man) { return Math.round((Number(man) || 0) / 1000) / 10; },
		areaP(p) { return Math.round((Number(p) || 0) * 100) / 100; },
	},
};
</script>

<style scoped>
.development-plan { display: flex; flex-direction: column; gap: 14px; }
.print-tit { margin-bottom: 14px; }
.dp-block-tit { font-size: 15px; font-weight: 700; display: flex; align-items: center; gap: 8px; }
.dp-block-tit i { width: 4px; height: 16px; background: #9b1c1c; display: inline-block; }
.dp-block-tit small { font-weight: 400; color: #888; font-size: 12px; }
.dp-two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
.dp-side-tit { font-size: 14px; font-weight: 700; margin-bottom: 6px; }
.dp-side-tit small { font-weight: 400; color: #888; font-size: 11px; }
.dp-table { width: 100%; border-collapse: collapse; }
.dp-table th { background: #f1ebe9; text-align: left; padding: 6px 7px; font-size: 12px; }
.dp-table th.num, .dp-table td.num { text-align: right; font-variant-numeric: tabular-nums; }
.dp-table td { padding: 6px 7px; border-bottom: 1px solid #eee; font-size: 12px; }
.dp-table td.basis { font-size: 10px; color: #888; line-height: 1.3; }
.dp-table tr.total td { font-weight: 700; color: #9b1c1c; border-bottom: none; }
.page-footer-disclaimer { margin-top: auto; }
.dp-sources-tit { font-size: 11px; font-weight: 700; color: #555; margin-bottom: 3px; }
.dp-sources { font-size: 10px; color: #888; line-height: 1.5; margin: 0 0 6px; padding-left: 15px; }
.dp-sources li { margin-bottom: 2px; }
.dp-disc { font-size: 10px; color: #888; line-height: 1.5; margin: 0 0 7px; }
.dp-legal { border-top: 1px solid rgba(0, 0, 0, 0.06); padding-top: 5px; }
.dp-legal p { margin: 0; font-size: 7.5px; line-height: 1.45; color: #6b6b6b; letter-spacing: -0.01em; text-indent: -6px; padding-left: 6px; word-break: keep-all; }
.dp-legal p + p { margin-top: 1px; }
.dp-assumption { font-size: 11px; color: #555; margin-bottom: 6px; padding-bottom: 5px; border-bottom: 1px solid #eee; }
.dp-note { font-size: 11px; color: #888; margin-top: 8px; line-height: 1.5; background: #faf7f6; padding: 10px; border-radius: 4px; }
.dp-cards { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
.dp-card { border: 1px solid #eee; border-radius: 6px; padding: 18px; }
.dp-card--primary { background: #7a1818; color: #fff; border-color: #7a1818; }
.dp-card-label { font-size: 12px; opacity: .85; }
.dp-card-value { font-size: 26px; font-weight: 700; margin: 8px 0; }
.dp-card-sub { font-size: 11px; opacity: .7; }
</style>
